import mainCaller from './mainCaller';

// 회원 보유 권별 출입문 현황 — 전환 지점의 제한 문 전체 + 상품/실효 여부
// branchId: 문을 볼 지점(로그인 지점). 다지점 공유 상품은 판매지점과 이용지점의 문이 각각이라 넘긴다.
export const getMemberAccessDoors = async (holdingType, holdingId, token, branchId) =>
  mainCaller(
    `admin/api/v1/member-access-doors?holdingType=${holdingType}&holdingId=${holdingId}${branchId ? `&branchId=${branchId}` : ''}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );

// 회원 보유 권별 출입문 저장 — 원하는 실효 제한 문 집합, 즉시 재계산·UBio 동기화
export const saveMemberAccessDoors = async (holdingType, holdingId, groupIds, token, branchId) =>
  mainCaller(
    `admin/api/v1/member-access-doors?holdingType=${holdingType}&holdingId=${holdingId}${branchId ? `&branchId=${branchId}` : ''}`,
    'PUT',
    { groupIds },
    { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  );
